import { Auth } from '@aws-amplify/auth';
import { VIBE_ATTR_PATH } from '../constants/api';
import {
  EULA_CONFIRMATION,
  EULA_GANDALF_PROFILE_FIELD,
} from '../constants/auth';
import { UPDATE_EULA } from '../constants/metrics';
import { GandalfUser } from '../types/auth';
import { request, joinUrlPath } from '../utils/apiHelper';

export function isEulaAccepted(user: GandalfUser) {
  return Boolean(user.eulaStatus?.toLowerCase() === EULA_CONFIRMATION);
}

export async function acceptEula(gandalfProfileEndpoint: string) {
  const opts: RequestInit = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
    },
    body: JSON.stringify({
      attributes: [
        {
          name: EULA_GANDALF_PROFILE_FIELD,
          attributeValue: {
            S: EULA_CONFIRMATION,
          },
        },
      ],
    }),
  };
  return request(joinUrlPath(gandalfProfileEndpoint, VIBE_ATTR_PATH), opts, {
    metricNs: UPDATE_EULA,
  }).then((response) => response.json());
}
